<div
  class="card"
  [class.blue-background]="blueBck"
>
  <ng-content></ng-content>
</div>
